import type { Domain } from '@/entities/domain';
import request from '@/shared/api/request';

export const createDomain = ({
  project_uuid,
  name,
}: {
  project_uuid?: string;
  name: string;
}): Promise<{ domain: Domain }> =>
  request({
    url: '/domains/',
    method: 'POST',
    data: { name, project_uuid },
  });
